// @generated by protoc-gen-es v1.6.0 with parameter "target=js"
// @generated from file dymensionxyz/dymension/gamm/v1beta1/tx_liquidity.proto (package dymensionxyz.dymension.gamm.v1beta1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from '@bufbuild/protobuf';
import { Coin } from './coin_pb';

/**
 * ===================== MsgJoinPool
 * This is really MsgJoinPoolNoSwap
 *
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.MsgJoinPool
 */
export const MsgJoinPool = proto3.makeMessageType(
  'dymensionxyz.dymension.gamm.v1beta1.MsgJoinPool',
  () => [
    { no: 1, name: 'sender', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'pool_id', kind: 'scalar', T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: 'share_out_amount', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'token_in_maxs', kind: 'message', T: Coin, repeated: true },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.MsgJoinPoolResponse
 */
export const MsgJoinPoolResponse = proto3.makeMessageType(
  'dymensionxyz.dymension.gamm.v1beta1.MsgJoinPoolResponse',
  () => [
    { no: 1, name: 'share_out_amount', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'token_in', kind: 'message', T: Coin, repeated: true },
  ],
);

/**
 * ===================== MsgExitPool
 *
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.MsgExitPool
 */
export const MsgExitPool = proto3.makeMessageType(
  'dymensionxyz.dymension.gamm.v1beta1.MsgExitPool',
  () => [
    { no: 1, name: 'sender', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'pool_id', kind: 'scalar', T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: 'share_in_amount', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'token_out_mins', kind: 'message', T: Coin, repeated: true },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.MsgExitPoolResponse
 */
export const MsgExitPoolResponse = proto3.makeMessageType(
  'dymensionxyz.dymension.gamm.v1beta1.MsgExitPoolResponse',
  () => [
    { no: 1, name: 'token_out', kind: 'message', T: Coin, repeated: true },
  ],
);

/**
 * ===================== MsgJoinSwapExternAmountIn
 * TODO: Rename to MsgJoinSwapExactAmountIn
 *
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.MsgJoinSwapExternAmountIn
 */
export const MsgJoinSwapExternAmountIn = proto3.makeMessageType(
  'dymensionxyz.dymension.gamm.v1beta1.MsgJoinSwapExternAmountIn',
  () => [
    { no: 1, name: 'sender', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'pool_id', kind: 'scalar', T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: 'token_in', kind: 'message', T: Coin },
    { no: 4, name: 'share_out_min_amount', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.MsgJoinSwapExternAmountInResponse
 */
export const MsgJoinSwapExternAmountInResponse = proto3.makeMessageType(
  'dymensionxyz.dymension.gamm.v1beta1.MsgJoinSwapExternAmountInResponse',
  () => [
    { no: 1, name: 'share_out_amount', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * ===================== MsgJoinSwapShareAmountOut
 *
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.MsgJoinSwapShareAmountOut
 */
export const MsgJoinSwapShareAmountOut = proto3.makeMessageType(
  'dymensionxyz.dymension.gamm.v1beta1.MsgJoinSwapShareAmountOut',
  () => [
    { no: 1, name: 'sender', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'pool_id', kind: 'scalar', T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: 'token_in_denom', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'share_out_amount', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'token_in_max_amount', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.MsgJoinSwapShareAmountOutResponse
 */
export const MsgJoinSwapShareAmountOutResponse = proto3.makeMessageType(
  'dymensionxyz.dymension.gamm.v1beta1.MsgJoinSwapShareAmountOutResponse',
  () => [
    { no: 1, name: 'token_in_amount', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * ===================== MsgExitSwapShareAmountIn
 *
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.MsgExitSwapShareAmountIn
 */
export const MsgExitSwapShareAmountIn = proto3.makeMessageType(
  'dymensionxyz.dymension.gamm.v1beta1.MsgExitSwapShareAmountIn',
  () => [
    { no: 1, name: 'sender', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'pool_id', kind: 'scalar', T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: 'token_out_denom', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'share_in_amount', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'token_out_min_amount', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.MsgExitSwapShareAmountInResponse
 */
export const MsgExitSwapShareAmountInResponse = proto3.makeMessageType(
  'dymensionxyz.dymension.gamm.v1beta1.MsgExitSwapShareAmountInResponse',
  () => [
    { no: 1, name: 'token_out_amount', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * ===================== MsgExitSwapExternAmountOut
 *
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.MsgExitSwapExternAmountOut
 */
export const MsgExitSwapExternAmountOut = proto3.makeMessageType(
  'dymensionxyz.dymension.gamm.v1beta1.MsgExitSwapExternAmountOut',
  () => [
    { no: 1, name: 'sender', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'pool_id', kind: 'scalar', T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: 'token_out', kind: 'message', T: Coin },
    { no: 4, name: 'share_in_max_amount', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.MsgExitSwapExternAmountOutResponse
 */
export const MsgExitSwapExternAmountOutResponse = proto3.makeMessageType(
  'dymensionxyz.dymension.gamm.v1beta1.MsgExitSwapExternAmountOutResponse',
  () => [
    { no: 1, name: 'share_in_amount', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ],
);

